const benefits = [
  { icon: "ri-volume-mute-line", title: "Whisper Quiet Sleep Mode", desc: "Runs as low as 22 dB on night settings, quieter than a gentle breeze for undisturbed rest.", color: "bg-sky-100", iconColor: "text-sky-600", border: "border-sky-100", },
  { icon: "ri-smartphone-line", title: "Smart App Control", desc: "Monitor and control air quality from your phone, wherever you are.", color: "bg-amber-100", iconColor: "text-amber-600", border: "border-amber-100", },
  { icon: "ri-hospital-line", title: "Medical-Grade Certified", desc: "FDA-cleared Airdog TPA technology trusted by hospitals and clinics worldwide.", color: "bg-rose-100", iconColor: "text-rose-600", border: "border-rose-100", },
  { icon: "ri-home-4-line", title: "Whole-Home Coverage", desc: "Effectively purifies spaces up to 4,000 sq ft with a single unit.", color: "bg-emerald-100", iconColor: "text-emerald-600", border: "border-emerald-100", },
  { icon: "ri-pulse-line", title: "Real-Time Air Display", desc: "Instant feedback on your indoor environment with built-in smart sensors.", color: "bg-violet-100", iconColor: "text-violet-600", border: "border-violet-100", },
  { icon: "ri-focus-3-line", title: "360° Surround Intake", desc: "Pulls in airborne particles from all directions for faster, more comprehensive room coverage.", color: "bg-orange-100", iconColor: "text-orange-600", border: "border-orange-100", },
];

export default function BenefitsSection() {
  return (
    <section id="benefits" className="min-h-[75vh] md:min-h-[85vh] flex flex-col justify-center py-6 md:py-8 bg-[#FAF8F5] scroll-mt-20 overflow-hidden relative z-0">
      <div className="mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid lg:grid-cols-2 gap-5 lg:gap-6 items-center">
          <div>
            <div className="relative w-[70%] mx-auto aspect-[3/2]">
              <img
                src="https://public.readdy.ai/ai/img_res/edited_ae717f9a0a6052c5319f8e5363d1e552_33be1ccb.jpg"
                alt="Serene wilderness landscape with misty water and lush greenery symbolizing pristine, untouched air quality"
                className="w-full h-full object-cover rounded-2xl"
              />
              <div className="absolute -bottom-4 -right-4 bg-white rounded-xl p-3 shadow-lg hidden md:block">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-[#E8F5F1] flex items-center justify-center">
                    <i className="ri-plant-line text-brand text-sm" />
                  </div>
                  <div>
                    <p className="text-[10px] text-gray-500">Inspired by</p>
                    <p className="text-xs font-semibold text-gray-900">Nature&apos;s Purity</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <span className="inline-block text-[11px] font-semibold tracking-wider text-brand uppercase mb-1">
              What Sets Us Apart
            </span>
            <h2 className="text-xl md:text-2xl lg:text-[2rem] font-bold text-gray-900 mb-2 leading-tight">
              Breathe Easy, Live Better
            </h2>
            <p className="text-sm text-gray-800 mb-4 leading-relaxed font-semibold">
              Airdog goes beyond basic filtration to deliver a complete air purification experience designed around your daily life.
            </p>
            <div className="grid sm:grid-cols-2 gap-2">
              {benefits.map((b, i) => (
                <div key={i} className={`flex gap-2 p-2.5 rounded-xl bg-white border ${b.border} hover:border-brand/20 hover:shadow-sm transition-all`}>
                  <div className={`w-8 h-8 rounded-lg ${b.color} flex items-center justify-center shrink-0`}>
                    <i className={`${b.icon} ${b.iconColor} text-sm`} />
                  </div>
                  <div>
                    <h3 className="font-black text-gray-900 text-xs mb-0.5">{b.title}</h3>
                    <p className="text-gray-700 text-[11px] leading-relaxed font-bold">{b.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}